import { apiClient } from 'src/utils/api-client';
import type { ApiClient } from 'src/utils/api-client';
import {
  ResidentAccountBookmark,
  ResidentAccountSummary,
  ResidentFavoriteModel,
} from './models';

export function fetchResidentLeasesService(
  includeAllResidents = false,
  client: ApiClient = apiClient,
) {
  return client.get<ResidentAccountSummary>(
    `/residents/summary?includeAllResidents=${includeAllResidents}`,
  );
}
export function fetchResidentBookmarksService(client: ApiClient = apiClient) {
  return client.get<ResidentAccountBookmark>('/residents/tours-apps');
}

export function fetchResidentFavorites(client: ApiClient = apiClient) {
  return client.get<ResidentFavoriteModel[]>('/residents/favorites');
}

type UpdateFavorite = { homeId: string; isFavorite: boolean };

export function updateResidentFavorite({ homeId, isFavorite }: UpdateFavorite) {
  return apiClient.put<void>(`/residents/${homeId}/favorite`, { isFavorite });
}
